import unitNameMap from '~/assets/json/unitTypes/unitNameMap.json';

export default function (shorthand) {
    return unitNameMap[shorthand] || shorthand;
}
